import PolygonStyle from '../Marker/MarkerStyle/PolygonStyle'
// import GroundPolygonPrimitive from './GroundPolygonPrimitive'

class GroundPolygonBundle {
  #viewer = undefined
  layerId = undefined
  style = undefined
  _collection = undefined
  _polygonCollection = undefined
  _polylineCollection = undefined

  polygonMap = {}
  billboardCluster = undefined

  _polygonPrimitives = {}
  _polylinePrimitives = {}

  constructor (viewer, options) {
    this.#viewer = viewer
    const _options = Cesium.defaultValue(options, {})
    this.layerId = Cesium.defaultValue(_options.layerId, undefined)
    this.style = Cesium.defaultValue(_options.style, PolygonStyle.Default())
    this.datas = Cesium.defaultValue(_options.datas, [])
    // const _color = Cesium.defaultValue(_options.color, Cesium.Color.WHITE)
    // const _outlineWidth = Cesium.defaultValue(_options.outlineWidth, 3)
    // const _outlineColor = Cesium.defaultValue(_options.outlineColor, Cesium.Color.BLUE)

    this._collection = new Cesium.PrimitiveCollection()
    this._collection.layerId = this.layerId
    this.#viewer.scene.primitives.add(this._collection)
    this._polygonCollection = new Cesium.PrimitiveCollection()
    this._collection.add(this._polygonCollection)
    this._polylineCollection = new Cesium.PrimitiveCollection()
    this._collection.add(this._polylineCollection)

    // 添加数据
    // this.datas.forEach(item => {
    //   this.add({
    //     positions: item.positions,
    //     id: item.id,
    //     color: _color,
    //     outlineWidth: _outlineWidth,
    //     outlineColor: _outlineColor
    //   })
    // })
    this.addBatch(options)
  }

  add (options) {
    // const primitive = new GroundPolygonPrimitive(options)
    // this._polygonCollection.add(primitive.polygonPrimitive)
    // this._polylineCollection.add(primitive.polylinePrimitive)

    const _options = Cesium.defaultValue(options, {})
    const _color = Cesium.defaultValue(_options.color, Cesium.Color.WHITE)
    const _outlineWidth = Cesium.defaultValue(_options.outlineWidth, 3)
    const _outlineColor = Cesium.defaultValue(_options.outlineColor, Cesium.Color.BLUE)

    const polygonGeometry = new Cesium.PolygonGeometry({
      polygonHierarchy: new Cesium.PolygonHierarchy(
        Cesium.Cartesian3.fromDegreesArray(options.positions)
      )
    })
    const polygonGeometryInstance = new Cesium.GeometryInstance({
      geometry: polygonGeometry,
      attributes: {
        color: Cesium.ColorGeometryInstanceAttribute.fromColor(_color)
      },
      id: options.id
    })
    this._polygonPrimitives[this.layerId].geometryInstances.push(polygonGeometryInstance)

    const polylineGeometry = new Cesium.GroundPolylineGeometry({
      positions: Cesium.Cartesian3.fromDegreesArray(options.positions),
      width: _outlineWidth
    })
    const polylineGeometryInstance = new Cesium.GeometryInstance({
      geometry: polylineGeometry,
      attributes: {
        color: Cesium.ColorGeometryInstanceAttribute.fromColor(_outlineColor)
      },
      id: options.id
    })
    this._polylinePrimitives[this.layerId].geometryInstances.push(polylineGeometryInstance)
  }

  addBatch (options) {
    const _options = Cesium.defaultValue(options, {})
    // const positions = Cesium.defaultValue(_options.positions, [])
    // const _id = Cesium.defaultValue(_options.id, undefined)
    const _color = Cesium.defaultValue(_options.color, Cesium.Color.WHITE)
    const _outlineWidth = Cesium.defaultValue(_options.outlineWidth, 3)
    const _outlineColor = Cesium.defaultValue(_options.outlineColor, Cesium.Color.BLUE)
    const datas = Cesium.defaultValue(_options.datas, [])

    const polygons = []
    const polylines = []
    for (let i = 0; i < datas.length; i++) {
      const data = datas[i]
      const polygonGeometry = new Cesium.PolygonGeometry({
        polygonHierarchy: new Cesium.PolygonHierarchy(
          data.isHaveHeight ? Cesium.Cartesian3.fromDegreesArrayHeights(data.positions) : Cesium.Cartesian3.fromDegreesArray(data.positions)
        )
      })
      const polygonGeometryInstance = new Cesium.GeometryInstance({
        geometry: polygonGeometry,
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(_color)
        },
        id: data.id
      })
      polygons.push(polygonGeometryInstance)

      const polylineGeometry = new Cesium.GroundPolylineGeometry({
        positions: data.isHaveHeight ? Cesium.Cartesian3.fromDegreesArrayHeights(data.positions) : Cesium.Cartesian3.fromDegreesArray(data.positions),
        width: _outlineWidth
      })
      const polylineGeometryInstance = new Cesium.GeometryInstance({
        geometry: polylineGeometry,
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(_outlineColor)
        },
        id: data.id
      })
      polylines.push(polylineGeometryInstance)
    }
    const _polygonPrimitive = new Cesium.GroundPrimitive({
      geometryInstances: polygons,
      appearance: new Cesium.PerInstanceColorAppearance()
    })
    _polygonPrimitive.layerId = this.layerId
    this._polygonCollection.add(_polygonPrimitive)
    this._polygonPrimitives[this.layerId] = _polygonPrimitive

    const _polylinePrimitive = new Cesium.GroundPolylinePrimitive({
      geometryInstances: polylines,
      appearance: new Cesium.PolylineColorAppearance()
    })
    _polylinePrimitive.layerId = this.layerId
    this._polylineCollection.add(_polylinePrimitive)
    this._polylinePrimitives[this.layerId] = _polylinePrimitive
  }

  get show () {
    return this._collection.show
  }

  set show (isShow) {
    this._collection.show = isShow
  }

  /**
   * 销毁所有多边形
   */
  destroy () {
    this.#viewer.scene.primitives.remove(this._collection)
    this._collection = undefined
    // this.billboardMap = {}
  }
}

export default GroundPolygonBundle
